import React from "react";
import { UnRestrictedRoute } from "./access-route"
import asyncComponent from "../helpers/async-func";


export default [
    <UnRestrictedRoute
      exact
      key="verification"
      path={"/login"}
      component={asyncComponent(() => import("../containers/verification"))}/>,
]


    
